import React, { useEffect, useState } from 'react';
import { CircleButton, NavigationItemLink, Typography } from '../../index';

export const NavigationSubItem = ({
    label,
    subNavItems,
    isSelectedLink = () => { },
    onDismiss = () => { },
    onSubItemClick = () => { },
    toggleMainMenu = () => { }
}) => {

    return <div className={`bsw-navigation__sliding-menu`}>
        <div className="bsw-navigation__sliding-menu-header">
            <CircleButton
                colorStyle='default'
                icon="chevron-left"
                size="small"
                onClick={(e) => { onDismiss(e, '', ''); }}
            />
            <Typography type="body-02" bold color="$color-primary-a2" tag="div">{label}</Typography>
        </div>
        <ul>
            {(subNavItems && subNavItems.length > 0) && subNavItems.map((navItem, index) => {

                return <li
                    className={`bsw-navigation__sub-item`}
                    data-key={index}
                    key={index}
                >
                    <NavigationItemLink
                        index={index}
                        key={index}
                        navItem={navItem}
                        onItemClick={(e, itemIndex, itemLabel) => { onSubItemClick(e, itemIndex, itemLabel); }}
                        isSelectedLink={(navLink, altUrls) => isSelectedLink(navLink, altUrls)}
                        toggleMainMenu={toggleMainMenu}
                    />
                </li>
            })}
        </ul>
    </div>
}
